import React, { useEffect, useState } from "react";
import { Container, Table, Button, Spinner, Pagination } from "react-bootstrap";
import axios from "axios";

const BlockedCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("admin_token");
  const headers = {
    Authorization: `Bearer ${token}`
  };
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const fetchBlockedCustomers = async (page = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/api/customers_a/blocked`, {
        headers,
        params: { page, per_page: perPage }
      });
      setCustomers(res.data.customers || []);
      setTotalPages(res.data.pagination.total_pages);
      setCurrentPage(page);
    } catch (err) {
      console.error("Error fetching blocked customers", err);
    } finally {
      setLoading(false);
    }
  };

  const handleUnblock = async (customerId) => {
    try {
      await axios.put(`${API_BASE}/api/customers_a/unblock/${customerId}`, {}, { headers });
      fetchBlockedCustomers(currentPage);
    } catch (err) {
      console.error("Error unblocking customer", err);
    }
  };

  useEffect(() => {
    fetchBlockedCustomers();
  }, []);

  return (
    <Container className="mt-4">
      <h3>Blocked Customers</h3>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Company Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Username</th>
                <th>Reason</th>
                <th>Blocked in</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c, i) => (
                <tr key={c.customer_id}>
                  <td>{(currentPage - 1) * perPage + i + 1}</td>
                  <td>{c.company_name}</td>
                  <td>{c.email}</td>
                  <td>{c.phone}</td>
                  <td>{c.username}</td>
                  <td>{c.block_reason}</td>
                  <td>{c.blocked_at}</td>
                  <td>
                    <Button size="sm" variant="success" onClick={() => handleUnblock(c.customer_id)}>
                      Unblock
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Pagination>
            <Pagination.First onClick={() => fetchBlockedCustomers(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => fetchBlockedCustomers(currentPage - 1)} disabled={currentPage === 1} />
            <Pagination.Item active>{currentPage}</Pagination.Item>
            <Pagination.Next onClick={() => fetchBlockedCustomers(currentPage + 1)} disabled={currentPage === totalPages} />
            <Pagination.Last onClick={() => fetchBlockedCustomers(totalPages)} disabled={currentPage === totalPages} />
          </Pagination>
        </>
      )}
    </Container>
  );
};

export default BlockedCustomers;
